import { DriverRanking } from '../../models/client-ranking';

export const getDriverTotalPrize = (driver: DriverRanking): number =>
  Number(driver.inertiaPrize ?? 0) + Number(driver.engineLoadPrize ?? 0);

export const formatDriverPrizeCurrency = (value: number): string =>
  new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
